var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-2 mx-0",attrs:{"color":"error"},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" "),(_vm.icon != '' && _vm.icon != null)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }